var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { Trans, withTranslation } from 'react-i18next';
var TitledContentBlock = /** @class */ (function (_super) {
    __extends(TitledContentBlock, _super);
    function TitledContentBlock() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TitledContentBlock.prototype.render = function () {
        return (React.createElement("div", { className: this.getClassNames() },
            this.props.icon && React.createElement("img", { src: this.props.icon, alt: "" }),
            this.props.title1 && React.createElement("h1", { className: "c-title c-title--style1" }, this.props.t(this.props.title1)),
            this.props.title2 && React.createElement("h2", { className: "c-title c-title--style2" }, this.props.t(this.props.title2)),
            this.props.content && (React.createElement("p", null,
                React.createElement(Trans, { i18nKey: this.props.content },
                    React.createElement("b", null),
                    React.createElement("br", null))))));
    };
    TitledContentBlock.prototype.getClassNames = function () {
        var classNames = ['c-titled-content-block'];
        if (!this.props.align) {
            classNames.push('h-text--center');
        }
        return classNames.join(' ');
    };
    return TitledContentBlock;
}(React.Component));
export default withTranslation()(TitledContentBlock);
